import CryptoJS from "crypto-js";

class CryptoToken {
  secretKey = process.env.VUE_APP_CRYPTOJS_KEY;

  encodeToBase64(content: string) {
    return CryptoJS.AES.encrypt(content, this.secretKey!).toString();
  }

  decodeFromBase64(content: string) {
    return CryptoJS.AES.decrypt(content, this.secretKey!).toString(
      CryptoJS.enc.Utf8
    );
  }

  generatePKCE() {
    const code_verifier = CryptoJS.lib.WordArray.random(32).toString(
      CryptoJS.enc.Base64url
    );
    const code_challenge = CryptoJS.SHA256(code_verifier).toString(
      CryptoJS.enc.Base64url
    );

    localStorage.setItem("code_verifier", code_verifier);
    localStorage.setItem("code_challenge", code_challenge);
  }
}

export default new CryptoToken();
